import { FC } from 'react';

import { Box, Grid, Typography } from '@mui/material';

import { useProductOrderContext } from 'src/contexts/ProductOrderProvider';

import OrderItem from '../OrderItem';
import { OrderType } from '../ServiceProducts';
import { PricingServiceTypes } from '../ServiceType';

export type Order = {
    id: number;
    name: string;
    image: string;
    price: number;
    quantity: number;
    options?: {
        oneOff?: {
            currency?: string;
            sales: number;
            commission: number | null;
        }[];
        monthly?: {
            currency?: string;
            sales: number;
            commission?: number | null;
        }[];
    };
};

interface OrdersListProps {
    orders: Order[];
    currency?: string;
    orderType: OrderType;
    serviceType: PricingServiceTypes;
    contractTerm: number;
    removeProduct: (id: number, type: OrderType) => void;
    isEditingDisabled?: boolean;
}

export const OrdersList: FC<OrdersListProps> = ({
    orders,
    orderType,
    currency,
    serviceType,
    contractTerm,
    removeProduct,
    isEditingDisabled = false,
}) => {
    const { removeOrderItem } = useProductOrderContext();
    if (!orders) return null;
    const handleRemoveProduct = (id: number) => {
        removeProduct(id, orderType);
        removeOrderItem(id);
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            gap={1}
            sx={{
                '& .MuiGrid-item': {
                    padding: '8px 16px 16px 8px',
                },
            }}
        >
            <Grid container spacing={2} width="100%">
                <Grid item xs={3} />
                {/* Set up heading */}
                <Grid
                    container
                    xs={8}
                    width="100%"
                    sx={{
                        borderBottom: '1px solid #575757',
                    }}
                >
                    <Grid item xs={3}>
                        <Typography
                            fontSize="20px"
                            fontWeight={600}
                            color="#1D1D1B"
                            textAlign="center"
                        >
                            Setup
                        </Typography>
                    </Grid>
                    {/* Qty heading */}
                    <Grid item xs={3}>
                        <Typography
                            fontSize="20px"
                            fontWeight={600}
                            color="#1D1D1B"
                            textAlign="center"
                        >
                            QTY
                        </Typography>
                    </Grid>
                    {/* Monthly rental heading */}
                    <Grid item xs={3}>
                        <Typography
                            fontSize="20px"
                            fontWeight={600}
                            color="#1D1D1B"
                            textAlign="center"
                        >
                            Monthly Rental
                        </Typography>
                    </Grid>
                    {/* Total Heading */}
                    <Grid item xs={3}>
                        <Typography
                            fontSize="20px"
                            fontWeight={600}
                            color="#1D1D1B"
                            textAlign="center"
                        >
                            Total
                        </Typography>
                    </Grid>
                </Grid>
                <Grid item xs={1} />
            </Grid>
            <Box
                sx={{
                    my: '12px',
                }}
            />
            <Grid
                container
                spacing={2}
                rowGap={1}
                width="100%"
                sx={{
                    '& .MuiGrid-item': {
                        padding: '8px 8px 8px 8px',
                    },
                }}
            >
                {orders.map((order) => {
                    return (
                        <OrderItem
                            currency={currency}
                            key={order?.id}
                            order={order}
                            removeProduct={handleRemoveProduct}
                            serviceType={serviceType}
                            contractTerm={contractTerm}
                            isEditingDisabled={isEditingDisabled}
                        />
                    );
                })}
            </Grid>
        </Box>
    );
};
export default OrdersList;
